import * as HLF from "html-living-framework";
import {Anchor} from "../core/Anchor";
import {Ease} from "../core/Animatable";
import {Callback} from "../core/Reflection";
import {Sprite} from "../core/Sprite";
import {Focusables} from "../gameobjects/Focusables";
import {MuteButton} from "../gameobjects/MuteButton";

export class LoadScreen extends HLF.LoadScreen {

    public static readonly NAME = "LoadScreen";

    public readonly bg = this.addChild(new Sprite(PIXI.Texture.WHITE, Anchor.middleCenter));
    public readonly loader = this.addChild(new Sprite());
    public buttonMute?: MuteButton;

    private _onLoaded?: Callback;
    private _isAnimatedIn = false;

    public init(pSize: PIXI.Point) {
        super.init(pSize);

        this._isAnimatedIn = false;
        this._onLoaded = undefined;

        this.loader.scale.set(1);
        this.loader.rotation = 0;
        this.loader.setLayoutTexture("loader", 0.5, 0.5);

        this.loader.killTweens();
        this.loader.scaleFrom(0, 0.2, Ease.sineOut, () => {
            this.loader.delayedCall(0.4, () => {
                this._isAnimatedIn = true;
                this.hideLoader();
            });
        });
        this.loader.tweenTo(1, Ease.none, {
            rotation: -Math.PI * 2,
            repeat: -1,
        });

        if (this.buttonMute) {
            this.buttonMute.destroy();
        }
        this.buttonMute = this.addChild(new MuteButton());
        this.buttonMute.setPosition(this._size);

        Focusables.clear();
        Focusables.add(this.buttonMute);
    }

    public onResize(pSize: PIXI.Point) {
        super.onResize(pSize);

        this.bg.width = this._size.x + 10;
        this.bg.height = this._size.y + 10;

        if (this.buttonMute) {
            this.buttonMute.setPosition(this._size);
        }
    }

    public onLoadComplete(pCallback: () => void): void {
        this._onLoaded = pCallback;
        this.hideLoader();
    }

    private hideLoader() {
        if (this._isAnimatedIn && this._onLoaded) {
            this.loader.scaleTo(0, 0.2, Ease.sineIn, () => {
                this.loader.delayedCall(0.1, () => {
                    this.loader.killTweens();
                    if (this._onLoaded) {
                        this._onLoaded();
                    }
                });
            });
        }
    }
}
